import { Skeleton } from "antd";

export default function SupplierSkeleton() {
  return (
    <section className="w-[442px] min-h-[615px] bg-white rounded-[12px]">
      <div className="px-5 py-[50px]">
        <div className="flex flex-col space-y-2">
          <label className="text-sm font-p_medium" htmlFor="supplierName">
            Supplier Name <span className="text-red-500">*</span>
          </label>
          <div className="w-full h-[48px] supplier-skeleton-inputs">
            <Skeleton.Input active={true} size={"square"} block={true} />
          </div>
        </div>

        <div className="flex flex-col space-y-2 mt-4 supplier-skeleton-inputs">
          <label className="text-sm font-p_medium" htmlFor="mobileNo">
            Mobile No <span className="text-red-500">*</span>
          </label>
          <div className="w-full h-[48px]">
            <Skeleton.Input active={true} size={"square"} block={true} />
          </div>
        </div>

        <div className="flex flex-col space-y-2 mt-4">
          <label className="text-sm font-p_medium" htmlFor="mobileNo">
            Address <span className="text-red-500">*</span>
          </label>
          <div className="w-full h-[133px] supplier-skeleton-text-area">
            <Skeleton.Input active={true} size={"square"} block={true} />
          </div>
        </div>

        <div className="w-full flex flex-col mt-9 space-y-2">
          <label className="text-sm font-p_medium">Ingredients</label>
          <div className="w-full h-[48px] supplier-skeleton-inputs mb-2">
            <Skeleton.Input active={true} size={"square"} block={true} />
          </div>
        </div>
      </div>

      <div className="flex items-center space-x-3 pb-[50px] px-5 h-[42px]">
        <div className="w-[100px] h-[42px] supplier-inputs-btns">
          <Skeleton.Button active={true} size={"square"} block={true} shape={"square"} />
        </div>
        <div className="w-[100px] h-[42px] supplier-inputs-btns">
          <Skeleton.Button active={true} size={"square"} block={true} shape={"square"} />
        </div>
      </div>
    </section>
  );
}
